export default __webpack_public_path__ + "static/media/banner2.5e8fc90d.jpg";